module.exports = __webpack_public_path__ + "media/packs/images/state/small/container-d0559793687fdc78669020fc0cfc225a.svg";